
import { Settings } from "lucide-react"
import { Button } from "./ui/button"
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select"
import { useState } from "react"

interface DashboardHeaderProps {
  onOrganizationChange?: (value: string) => void
  onTrackerChange?: (value: string) => void
}

export function DashboardHeader({ onOrganizationChange, onTrackerChange }: DashboardHeaderProps) {
  const [selectedOrganization, setSelectedOrganization] = useState("entire")
  const [selectedTracker, setSelectedTracker] = useState("all")

  const handleOrganizationChange = (value: string) => {
    setSelectedOrganization(value)
    onOrganizationChange?.(value)
  }

  const handleTrackerChange = (value: string) => {
    setSelectedTracker(value)
    onTrackerChange?.(value)
  }

  return (
    <header className="border-b border-border bg-card">
      <div className="container mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="flex items-center gap-2">
              <h1 className="text-2xl font-bold text-foreground">Organizational Insights</h1>
            </div>
          </div>

          <div className="flex items-center gap-4">
            <div className="flex items-center gap-2">
              <Select value={selectedOrganization} onValueChange={handleOrganizationChange}>
                <SelectTrigger className="w-48">
                  <SelectValue placeholder="Groups Tracked" />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="entire">All Teams</SelectItem>
                  <SelectItem value="engineering">Engineering</SelectItem>
                  <SelectItem value="product">Product</SelectItem>
                  <SelectItem value="design">Design</SelectItem>
                  <SelectItem value="marketing">Marketing</SelectItem>
                  <SelectItem value="sales">Sales</SelectItem>
                  <SelectItem value="support">Support</SelectItem>
                </SelectContent>
              </Select>
            </div>

            <div className="flex items-center gap-2">
              <Select value={selectedTracker} onValueChange={handleTrackerChange}>
                <SelectTrigger className="w-40">
                  <SelectValue placeholder="Select tracker" />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="all">All Trackers</SelectItem>
                  <SelectItem value="pricing-confusion">Pricing Confusion</SelectItem>
                  <SelectItem value="support-response">Support Response Time</SelectItem>
                  <SelectItem value="dashboard-ui">Dashboard 2.0 UI</SelectItem>
                  <SelectItem value="onboarding-flow">Onboarding Flow Issues</SelectItem>
                  <SelectItem value="feature-requests">Feature Request Excitement</SelectItem>
                  <SelectItem value="api-integration">API Integration Challenges</SelectItem>
                </SelectContent>
              </Select>
            </div>

            <Button variant="outline" size="sm">
              <Settings className="h-4 w-4 mr-2" />
              Settings
            </Button>
          </div>
        </div>
      </div>
    </header>
  )
}
